"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCart = void 0;
var events_1 = require("../../utils/events");
var AjaxApi_1 = require("../../shopify/AjaxApi");
var CartItem_1 = require("./CartItem");
var index_1 = require("../../index");
var hooks_1 = require("./hooks");
var BaseCart = /** @class */ (function () {
    function BaseCart() {
        this.items = [];
        this.attributes = {};
        this.note = '';
        this.token = 'unknown';
        this.totalPrice = 0;
        this.totalWeight = 0;
        this.requiresShipping = false;
        this.currency = 'GBP';
        this._onChange = new events_1.SimpleEvent();
        this.api = new AjaxApi_1.AjaxApi();
        this._$log = null;
        this.queryTypes = {};
        (0, hooks_1.monitorForCartChanges)(this);
    }
    Object.defineProperty(BaseCart.prototype, "onChange", {
        /**
         * Fires every time the cart is modified.
         */
        get: function () {
            return this._onChange;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCart.prototype, "$log", {
        get: function () {
            if (!this._$log) {
                this._$log = new index_1.TaggedLog(index_1.log, 'Cart');
            }
            return this._$log;
        },
        enumerable: false,
        configurable: true
    });
    BaseCart.prototype.addQueryType = function (key, fn) {
        this.queryTypes[key] = fn;
    };
    // Adds items to the cart
    BaseCart.prototype.addItem = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var modified;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addItems([item])];
                    case 1:
                        modified = _a.sent();
                        if (!modified[0]) {
                            throw new Error("Added item not returned from add call");
                        }
                        return [2 /*return*/, modified[0]];
                }
            });
        });
    };
    /**
     * Add items to the cart.
     *
     * @returns Items that were added or modified.
     */
    BaseCart.prototype.addItems = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var result, modified, existingItemsByKey, _a, _b, item, _c, _d, item, newItem, existingItem;
            var e_1, _e, e_2, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, this.api.cartAdd({
                            items: items.map(function (item) { return (__assign({ quantity: 1 }, item)); }),
                        })];
                    case 1:
                        result = _g.sent();
                        modified = [];
                        existingItemsByKey = {};
                        try {
                            for (_a = __values(this.items), _b = _a.next(); !_b.done; _b = _a.next()) {
                                item = _b.value;
                                existingItemsByKey[item.key] = item;
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        try {
                            for (_c = __values(result.items), _d = _c.next(); !_d.done; _d = _c.next()) {
                                item = _d.value;
                                newItem = new CartItem_1.CartItem(this, item);
                                modified.push(newItem);
                                existingItem = existingItemsByKey[item.key];
                                if (existingItem) {
                                    this.items.splice(this.items.indexOf(existingItem), 1, newItem);
                                }
                                else {
                                    this.items.push(newItem);
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        // Start reload in background to get new totals
                        void this.reload();
                        this.onChange.dispatch();
                        return [2 /*return*/, modified];
                }
            });
        });
    };
    // Update the cart
    BaseCart.prototype.updateNote = function (note) {
        return this.update(note, null);
    };
    BaseCart.prototype.updateAttributes = function (attributes) {
        return this.update(null, attributes);
    };
    BaseCart.prototype.update = function (note, attributes) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.cartUpdate({
                            note: note || undefined,
                            attributes: attributes || undefined,
                        })];
                    case 1:
                        result = _a.sent();
                        this.populate(result);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update item quantities by line position. DOES NOT VALIDATE STOCK AVAILABILITY (see Ajax API docs.)
     */
    BaseCart.prototype.updateItemQuantities = function (updates) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (updates.length != this.items.length) {
                            throw new Error("Number of updates must match the number of items in the cart.");
                        }
                        return [4 /*yield*/, this.api.cartUpdate({
                                updates: updates,
                            })];
                    case 1:
                        result = _a.sent();
                        this.populate(result);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update item quantities using variant IDs
     *
     * @deprecated Updating item quantities using this method is unsafe when attributes,
     * selling plans, etc. are used -- consider using the updateItemQuantities() method
     * or the change() methods on the individual items instead!
     */
    BaseCart.prototype.updateItemQuantitiesByVariantId = function (updates) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.cartUpdate({
                            updates: updates,
                        })];
                    case 1:
                        result = _a.sent();
                        this.populate(result);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Filter and return cart items.
     */
    BaseCart.prototype.queryItems = function (query) {
        var e_3, _a;
        var items = this.items;
        try {
            for (var _b = __values(Object.keys(query)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var queryFn = this.queryTypes[key];
                if (!queryFn) {
                    throw new Error("Unknown query type '".concat(key));
                }
                var arg = query[key];
                items = queryFn(items, arg);
                if (items.length < 1) {
                    break;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return items;
    };
    /**
     * Empty the cart.
     *
     * Performs a request to `/cart/clear`.
     */
    BaseCart.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.cartClear()];
                    case 1:
                        result = _a.sent();
                        this.populate(result);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Reload cart state.
     */
    BaseCart.prototype.reload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.cartGet()];
                    case 1:
                        result = _a.sent();
                        this.populate(result);
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseCart.prototype.populate = function (data) {
        var _this = this;
        this.items = data.items.map(function (item) { return new CartItem_1.CartItem(_this, item); });
        this.attributes = data.attributes;
        this.note = data.note;
        this.token = data.token;
        this.totalPrice = data.total_price;
        this.totalWeight = data.total_weight;
        this.requiresShipping = data.requires_shipping;
        this.currency = data.currency;
        this.onChange.dispatch();
    };
    /**
     * Remove an item from the cart. You can call .remove() on the item directly as well.
     */
    BaseCart.prototype.removeItem = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var line, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        line = this.items.indexOf(item);
                        if (line < 0) {
                            throw new Error("That item isn't in the cart.");
                        }
                        return [4 /*yield*/, this.api.cartChange({
                                line: line + 1,
                                quantity: 0,
                            })];
                    case 1:
                        result = _a.sent();
                        this.populate(result);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Change an item. You can call the item's .change() methods directly as well.
     */
    BaseCart.prototype.changeItem = function (item, quantity, properties) {
        return __awaiter(this, void 0, void 0, function () {
            var line, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        line = this.items.indexOf(item);
                        if (line < 0) {
                            throw new Error("That item isn't in the cart.");
                        }
                        return [4 /*yield*/, this.api.cartChange({
                                line: line + 1,
                                quantity: quantity || undefined,
                                properties: properties || undefined,
                            })];
                    case 1:
                        result = _a.sent();
                        this.populate(result);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Indicate that a third party has modified the cart and the state should be reloaded.
     *
     * In most cases this will be detected automatically, but you may call this directly
     * if an app somehow updates the cart without triggering the framework's checks.
     */
    BaseCart.prototype.notifyCartUpdatedExternally = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$log.internal('Cart was updated externally, updating.');
                        return [4 /*yield*/, this.reload()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return BaseCart;
}());
exports.BaseCart = BaseCart;
//# sourceMappingURL=BaseCart.js.map